class SpeechRecorder {

    mode = "once"; // "single" or "multiple"
    mediaRecorder;
    isPlaying;
    audio = null;
    audios;
    audioChunks = []

    props;
    constructor(props) {
        this.audios = []
    }

    setMode(prop) {
        this.mode = prop
    }



    playSelectedAudio(index) {
        (new Audio(self.audios[index])).play();
    }

    getLatestAudio() {
        return this.audio
    }

    clearSavedAudios() {
        this.audio = null;
        this.audios = [];
    }

    clearStream() {
        this.stream.getTracks().forEach(track => track.stop());
    }

    startRecord() {
        let self = this;
        this.isPlaying = true;

        navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
            self.mediaRecorder = new MediaRecorder(stream, {
                mimeType: 'audio/webm'
            });
            this.audioChunks = [];
            this.stream = stream
            self.mediaRecorder.addEventListener("dataavailable", event => {
                self.audioChunks.push(event.data);

            });

            self.mediaRecorder.addEventListener("onstop", () => {
                stream.getTracks().forEach(track => track.stop());
            });

            self.mediaRecorder.addEventListener("stop", () => {
                stream.getTracks().forEach(track => track.stop());
                stream.getTracks()[0].enable = false
                // console.log(stream.getTracks())
            });

            self.mediaRecorder.start();
            // console.log("record start");
        });
    }

    stopRecord() {
        let self = this
        return new Promise((resolve, reject) => {
            self.mediaRecorder.addEventListener("stop", () => {
                // console.log("record stopped")
                const audioBlob = new Blob(this.audioChunks, { 'type': 'audio/webm' });
                self.audio = audioBlob
                self.stream.getTracks().forEach(track => track.stop());
                resolve(audioBlob)
                if (!audioBlob) {
                    reject(new Error("Error: No audio blob is created."))
                }
            });

            this.isPlaying = false;
            if (this.mediaRecorder.state === 'recording') {
                this.mediaRecorder.stop();
                self.stream.getTracks().forEach(track => track.stop());
            }

            self.mediaRecorder.addEventListener("onstop", () => {
                self.stream.getTracks().forEach(track => track.stop());
            });
        })

    }

}

// Using singleton to share audio data across components.

export const speechRecorder = new SpeechRecorder();
